module.exports = __webpack_public_path__ + "img/brain-2062057_640.b05d5407.jpg";